import { createStore, persist } from 'easy-peasy'

import { storeModel } from './store.model'

// The auth slice must NOT be persisted (easy-peasy defaults to sessionStorage
// with everything included):
// - keycloakInitDone is strictly per-page-load — rehydrating it as true would
//   disable App.tsx's init gate on reload and bootstrap a stale SSO token.
// - auth.token would be resurrected by App.tsx "Case 3" after the Keycloak
//   handlers cleared localStorage; the canonical persisted copy of the token
//   is localStorage.token, restored by App.tsx "Case 2".
// version: 1 — easy-peasy's `deny` filters only at WRITE time; rehydration
// merges the whole stored blob unfiltered. Bumping the version changes the
// storage key ([EasyPeasyStore][1]) so tabs holding a pre-deny snapshot
// (which still contains the auth slice) don't rehydrate it once after deploy.
const store = createStore(persist(storeModel, { deny: ['auth'] }), {
  version: 1,
})
export default store
